import { logout } from "@/services/auth"
import { useLayoutEffect } from "react"

export function LogoutPage() {
  useLayoutEffect(() => {
    void logout()
  }, [])

  return false
}
